/**
 * PkPoliceVerknuepfenDialog - manually link a police to the placement (P2 Slice 15, Tab 6).
 */
import { useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

const CODE_TEXT: Record<string, string> = {
  policy_not_found: 'Keine aktive Police mit dieser Nummer beim gleichen Versicherer und Kunden gefunden.',
  policy_subject_mismatch: 'Die Police gehoert zu einem anderen Kunden.',
  policy_already_linked: 'Diese Police ist bereits einer anderen Ausschreibung zugeordnet.',
  antrag_status_invalid: 'Der Antrag ist in einem Status, der keine Verknuepfung erlaubt.',
  bereits_abgeschlossen: 'Die Ausschreibung ist bereits abgeschlossen.',
  policy_number_required: 'Bitte eine Policennummer eingeben.',
};

export function PkPoliceVerknuepfenDialog({
  open,
  onClose,
  onVerknuepfen,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  onVerknuepfen: (policyNumber: string) => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const [nr, setNr] = useState('');
  const errorText = error?.code ? CODE_TEXT[error.code] ?? 'Verknuepfung fehlgeschlagen' : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Police verknuepfen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={saving || nr.trim().length < 1} onClick={() => onVerknuepfen(nr.trim())} data-testid="pk-verknuepfen-submit">
            Police verknuepfen
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="pk-verknuepfen-dialog">
        <p className="text-xs text-muted-foreground">Gleicher Versicherer und Kunde wie der Antrag.</p>
        <label className="block">
          <span className="text-xs text-muted-foreground">Policennummer</span>
          <input value={nr} onChange={(e) => setNr(e.target.value)} maxLength={100} className="mt-1 w-full rounded-md border border-border p-2" data-testid="pk-verknuepfen-nummer" />
        </label>
        {errorText && <p className="text-sm text-status-danger" data-testid="pk-verknuepfen-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
